import type { CarroselDataCMS } from '.'

function verifyOptionsImage({
  carroselContent,
  carroselConfig,
}: CarroselDataCMS): string | undefined {
  if (!carroselContent?.enableImage) {
    if (carroselConfig?.backgroundFullImage) {
      return 'FullBackground'
    }

    return 'Full'
  }

  return undefined
}

export function renderImagemFullBackgroundOrNo({
  carroselContent,
  carroselConfig,
}: CarroselDataCMS) {
  const optionsImage = verifyOptionsImage({
    carroselContent,
    carroselConfig,
  })

  if (optionsImage === 'FullBackground') {
    return {
      // opacity: '0.65',
      height: '100%',
    }
  }

  if (optionsImage === 'Full') {
    return {
      height: '100%',
    }
  }

  return {
    opacity: '1',
  }
}

export function insertClassNameAccordingToDeviceAndImageOptions({
  carroselContent,
  carroselConfig,
}: CarroselDataCMS) {
  const optionsImage = verifyOptionsImage({
    carroselContent,
    carroselConfig,
  })

  if (optionsImage !== undefined) {
    return 'fullText'
  }

  return ''
}

export function getImageWithCertainResolution({
  screenWidth,
  carroselContent,
}: {
  screenWidth: number
  carroselContent: any
}) {
  if (screenWidth > 1024) {
    return {
      image: {
        src: carroselContent?.imageDesktop,
      },
      height: 350,
    }
  }

  if (screenWidth > 480 && screenWidth <= 1024) {
    return {
      image: {
        src: carroselContent?.imageTablet,
      },
      height: 260,
    }
  }

  return {
    image: {
      src: carroselContent?.imageMobile,
    },
    height: 140,
  }
}
